import { render, staticRenderFns } from "./ChipAplication.vue?vue&type=template&id=16634610&scoped=true&"
import script from "./ChipAplication.vue?vue&type=script&lang=ts&"
export * from "./ChipAplication.vue?vue&type=script&lang=ts&"
import style0 from "./ChipAplication.vue?vue&type=style&index=0&id=16634610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16634610",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('16634610', component.options)
    } else {
      api.reload('16634610', component.options)
    }
    module.hot.accept("./ChipAplication.vue?vue&type=template&id=16634610&scoped=true&", function () {
      api.rerender('16634610', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MultiApp/reusables/ChipAplication.vue"
export default component.exports